import { render, staticRenderFns } from "./pmconfiguration.vue?vue&type=template&id=00df34fe&scoped=true&"
import script from "./pmconfiguration.vue?vue&type=script&lang=ts&"
export * from "./pmconfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./pmconfiguration.vue?vue&type=style&index=0&id=00df34fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df34fe",
  null
  
)

export default component.exports